import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "surface-200 p-3 border-round-xl w-full" }
const _hoisted_2 = { class: "flex flex-column bg-white border-round-lg p-3 gap-3" }
const _hoisted_3 = { class: "relative flex align-items-center w-full pointer-events-auto" }
const _hoisted_4 = ["placeholder"]
const _hoisted_5 = { class: "flex flex-column gap-2 max-h-25rem overflow-auto" }
const _hoisted_6 = {
  key: 0,
  class: "py-3 px-2"
}
const _hoisted_7 = ["onClick", "onKeyup"]
const _hoisted_8 = ["onClick", "onKeyup"]
const _hoisted_9 = { class: "flex align-items-center gap-2 bg-white border-1 border-400 border-round-3xl py-2 px-3 text-base" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-check-circle" }, null, -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-angle-down" }, null, -1)
const _hoisted_12 = { class: "surface-200 p-3 border-round-xl w-full mt-2" }
const _hoisted_13 = { class: "flex flex-column bg-white border-round-lg p-3 gap-3" }
const _hoisted_14 = {
  key: 0,
  class: "text-sm"
}
const _hoisted_15 = { class: "checkbox flex flex-column sm:flex-row gap-2" }
const _hoisted_16 = { class: "flex justify-content-end gap-3 mt-4 w-full" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Checkbox = _resolveComponent("Checkbox")!
  const _component_Menu = _resolveComponent("Menu")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("strong", null, _toDisplayString(_ctx.$t("news.sub_notifications")), 1),
        _createElementVNode("span", null, _toDisplayString(_ctx.$t("news.sub_notifications_desc")), 1),
        _createElementVNode("div", _hoisted_3, [
          _withDirectives(_createElementVNode("input", {
            tabindex: "1",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.searchQuery) = $event)),
            class: "addressSearch",
            placeholder: _ctx.$t('news.provider_search'),
            type: "text",
            onKeyup: _cache[1] || (_cache[1] = _withKeys(
//@ts-ignore
(...args) => (_ctx.loadProviders && _ctx.loadProviders(...args)), ["enter"]))
          }, null, 40, _hoisted_4), [
            [_vModelText, _ctx.searchQuery]
          ]),
          (_ctx.searchQuery === '')
            ? (_openBlock(), _createElementBlock("i", {
                key: 0,
                class: "icon-warpit_icon_search absolute right-0 mr-3 cursor-pointer",
                onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.loadProviders && _ctx.loadProviders(...args)))
              }))
            : (_openBlock(), _createElementBlock("i", {
                key: 1,
                class: "icon-warpit_icon_x absolute right-0 mr-3 cursor-pointer",
                onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.searchQuery = ''))
              }))
        ]),
        _createElementVNode("div", _hoisted_5, [
          (_ctx.searchQuery && _ctx.searchedProviders?.length === 0)
            ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(_ctx.$t("news.empty")), 1))
            : _createCommentVNode("", true),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.searchedProviders, (provider) => {
            return (_openBlock(), _createElementBlock("div", {
              key: provider.id,
              class: "flex justify-content-between align-items-center py-3 px-2"
            }, [
              _createElementVNode("span", null, _toDisplayString(provider.title), 1),
              (provider.subscribed === false)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    tabindex: "1",
                    class: "bg-white border-1 border-400 border-round-3xl py-2 px-3 text-base cursor-pointer",
                    onClick: ($event: any) => (_ctx.updateSubscription(provider, true)),
                    onKeyup: _withKeys(($event: any) => (_ctx.updateSubscription(provider, true)), ["enter"])
                  }, _toDisplayString(_ctx.$t("news.turn_on_notifications")), 41, _hoisted_7))
                : (_openBlock(), _createElementBlock("div", {
                    key: 1,
                    tabindex: "1",
                    class: "flex align-items-center gap-2 cursor-pointer",
                    onClick: 
              (e) => {
                _ctx.selectedProvider = provider;
                _ctx.toggle(e);
              }
            ,
                    onKeyup: _withKeys(
              (e) => {
                _ctx.selectedProvider = provider;
                _ctx.toggle(e);
              }
            , ["enter"])
                  }, [
                    _createElementVNode("div", _hoisted_9, [
                      _hoisted_10,
                      _createTextVNode(" " + _toDisplayString(_ctx.$t("news.notifications_on")), 1)
                    ]),
                    _hoisted_11
                  ], 40, _hoisted_8))
            ]))
          }), 128))
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_12, [
      _createElementVNode("div", _hoisted_13, [
        _createElementVNode("strong", null, _toDisplayString(_ctx.$t("news.notifications")), 1),
        _createElementVNode("span", null, _toDisplayString(_ctx.$t("news.notifications_source")), 1),
        (!_ctx.user.phone_number)
          ? (_openBlock(), _createElementBlock("span", _hoisted_14, [
              _createTextVNode(_toDisplayString(_ctx.$t("my_waste.sms_disabled")) + " ", 1),
              _createVNode(_component_router_link, { to: { name: 'MyProfile' } }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t("user.my_profile")), 1)
                ]),
                _: 1
              }),
              _createTextVNode(". ")
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_15, [
          _createElementVNode("div", {
            class: _normalizeClass(["flex gap-3 align-items-center justify-content-between border-1 border-gray-300 p-2 border-round-md w-full text-base", {
            'bg-primary': _ctx.subscribe.providers_phone,
            'bg-gray-300': !_ctx.user.phone_number,
          }])
          }, [
            _createElementVNode("span", {
              class: "h-full w-full cursor-pointer",
              onClick: _cache[4] || (_cache[4] = _withModifiers(($event: any) => (_ctx.subscribe.providers_phone = !_ctx.subscribe.providers_phone), ["stop"]))
            }, _toDisplayString(_ctx.$t("my_waste.private.channels.sms")), 1),
            _createVNode(_component_Checkbox, {
              disabled: !_ctx.user.phone_number,
              modelValue: _ctx.subscribe.providers_phone,
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.subscribe.providers_phone) = $event)),
              binary: true
            }, null, 8, ["disabled", "modelValue"])
          ], 2),
          _createElementVNode("div", {
            class: _normalizeClass(["flex gap-1 align-items-center justify-content-between border-1 border-gray-300 p-2 border-round-md w-full text-base", { 'bg-primary': _ctx.subscribe.providers_push }])
          }, [
            _createElementVNode("span", {
              class: "h-full w-full cursor-pointer",
              onClick: _cache[6] || (_cache[6] = _withModifiers(($event: any) => (_ctx.subscribe.providers_push = !_ctx.subscribe.providers_push), ["stop"]))
            }, _toDisplayString(_ctx.$t("my_waste.private.channels.push")), 1),
            _createVNode(_component_Checkbox, {
              modelValue: _ctx.subscribe.providers_push,
              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.subscribe.providers_push) = $event)),
              binary: true
            }, null, 8, ["modelValue"])
          ], 2),
          _createElementVNode("div", {
            class: _normalizeClass(["flex gap-3 align-items-center justify-content-between border-1 border-gray-300 p-2 border-round-md w-full text-base", { 'bg-primary': _ctx.subscribe.providers_mail }])
          }, [
            _createElementVNode("span", {
              class: "h-full w-full cursor-pointer",
              onClick: _cache[8] || (_cache[8] = _withModifiers(($event: any) => (_ctx.subscribe.providers_mail = !_ctx.subscribe.providers_mail), ["stop"]))
            }, _toDisplayString(_ctx.$t("my_waste.private.channels.email")), 1),
            _createVNode(_component_Checkbox, {
              modelValue: _ctx.subscribe.providers_mail,
              "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.subscribe.providers_mail) = $event)),
              binary: true
            }, null, 8, ["modelValue"])
          ], 2)
        ]),
        _createElementVNode("div", _hoisted_16, [
          _createElementVNode("button", {
            class: "border-none text-primary bg-transparent cursor-pointer",
            onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.$router.push({ name: 'News', query: { view: 'for-you' } })))
          }, _toDisplayString(_ctx.$t("global.cancel")), 1),
          _createElementVNode("button", {
            class: "flex gap-2 bg-primary border-none py-2 px-3 border-round-3xl shadow-2 cursor-pointer",
            onClick: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.saveSubscriptions && _ctx.saveSubscriptions(...args)))
          }, _toDisplayString(_ctx.$t("news.save")), 1)
        ])
      ])
    ]),
    _createVNode(_component_Menu, {
      ref: "menu",
      model: [
      {
        label: _ctx.$t('news.turn_off_notifications'),
        command: () => {
          if (_ctx.selectedProvider) {
            _ctx.updateSubscription(_ctx.selectedProvider, false);
          }
        },
      },
    ],
      popup: true
    }, null, 8, ["model"])
  ], 64))
}